module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sidebarCurrentPanel === 'types'),
      expression: "sidebarCurrentPanel === 'types'"
    }],
    staticClass: "kp-modular-submenu kp-modular-submenu-tab kp-animate-tab-open"
  }, [_c('div', {
    staticClass: "kp-modular-tab pt-page no-fade pt-page-current"
  }, [_c('header', {
    staticClass: "kp-modular-title"
  }, [_vm._v(_vm._s(_vm.$t('general.labels.themes')))]), _vm._v(" "), _c('div', {
    staticClass: "submenu-content sub-color"
  }, [_c('type-header'), _vm._v(" "), _c('type-popup'), _vm._v(" "), _c('type-fullscreen'), _vm._v(" "), _c('type-component'), _vm._v(" "), _c('type-slider'), _vm._v(" "), _c('type-mini-slide')], 1)])])
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-0a3eb850!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/sidebar/types/Main.vue
 ** module id = 756
 ** module chunks = 1
 **/